import { useAlerts } from "components/Alerts/AlertProvider";
import { DialogMode, DialogType, useMinimizedDialogs } from "providers/minimizedDialogs";
import { useCallback } from "react";

import { useRetryDocumentExtractions } from "./useRetryDocumentExtractionsMutation";

interface UseRetryDocumentExtractionProps {
  onSuccess?: () => void;
}

export const useRetryDocumentExtraction = (props?: UseRetryDocumentExtractionProps) => {
  const [retryMutation, result] = useRetryDocumentExtractions({
    onSuccess: props?.onSuccess,
  });
  const { createDialog } = useMinimizedDialogs();
  const alerts = useAlerts();

  const retryDocumentExtractions = useCallback(
    async (tenantId: string, documentIds: string[], mode: DialogMode = "minimizedInTray") => {
      try {
        if (!tenantId) {
          throw new Error("No tenant ID found");
        }
        const job = await retryMutation({
          variables: {
            tenantId,
            documentIds,
          },
        });
        const jobId = job.data?.queueDocumentAIEnrichmentJobExisting.id;
        const dialogId = `document-ai-analyzing-${jobId}`;
        createDialog({
          id: dialogId,
          dialogType: DialogType.DocumentAIAnalyzing,
          props: {
            open: true,
            jobId: jobId,
            dialogId: dialogId,
          },
          mode: mode,
        });
      } catch (error) {
        alerts.error("Failed to retry document extractions", error);
      }
    },
    [retryMutation, createDialog, alerts]
  );

  return { retryDocumentExtractions, result };
};
